import { gql } from "@apollo/client";
import { myDynosFields, userFields } from "../fields";

export const EDSHOP_SIGNUP = gql`
  mutation EdShopSignUp($data: EdshopifySignUpInput!) {
    edshopifySignUp(data: $data) {
      id
      firstName
      lastName
      username
      email
      phone
    }
  }
`;

export const EDSHOP_INVITE = gql`
  mutation InviteEdShopifyMember($where: PublisherWhereUniqueInput!, $data: InviteEdShopifyMemberInput!) {
    inviteEdShopifyMember(where: $where, data: $data) {
      id
      firstName
      lastName
      username
      email
      phone
      isActive
    }
  }
`;

export const UPDATE_EDSHOP_MEMBER = gql`
  mutation UpdateEdshopifyMember($where: UpdateEdshopifyMemberWhereInput!, $data: UpdateEdshopifyMemberInput!) {
    updateEdshopifyMember(where: $where, data: $data) {
      id
      firstName
      lastName
      email
      isActive
    }
  }
`;

export const UPDATE_CATALOG = gql`
  mutation UpdateCatalog($data:  CatalogUpdateInput!, $where: CatalogWhereUniqueInput!) {
    updateCatalog(data: $data, where: $where) {
        id
        catalogName
        heading
        subHeading
        catalogAdmins {
          ${userFields}
        }
        catalogStatus
        description
        products(orderBy: { createdAt: desc }){
          id
          productName
          productStatus
        }
      }
  }
`;
export const CREATE_PRODUCT = gql`
  mutation EdshopifyCreateStripeProduct($data:  ProductCreateInput!, $where: EdshopifyCreateStripeProductWhereInput!) {
    edshopifyCreateStripeProduct(data: $data, where: $where) {
      id
      productName
      productStatus
      productCategory {
        id
        name
        parentCategory {
          id
          name
        }
      }
      productContent {
        dynoList {
          id
          listName
          dynosUnderList {
            id
            dyno {
              id
              dynoTitle
              dynoType {
                name
              }
            }
          }
        }
      }
      catalog {
        id
        catalogName
      }
    }
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct(
    $where: ProductWhereUniqueInput!
    $data: ProductUpdateInput!
  ) {
    updateProduct(where: $where, data: $data) {
      id
      productName
      productType
      productHeading
      productDescription
      productStatus
      productPricingType
      isAddedToStore
      productAdmins {
        ${userFields}
      }
      productCategory {
        id
        name
        parentCategory {
          id
          name
        }
      }
      productContent {
        id
        dynoList {
          id
          listIndex
        }
      }
      productSubscriptionPlans {
        id
        planName
        planShortDescription
        price
        currency
        frequency
      }
      productOneTimePlans {
        id
        planName
        price
        currency
        planShortDescription
        planLongDescription
      }
      catalogId
      catalog {
        catalogName
      }
    }
  }
`;

export const CREATE_PRODUCT_SUBSCRIPTION_PLAN = gql`
  mutation EdshopifyCreateSubscriptionPriceForProduct(
    $data: EdshopifyCreateSubscriptionPriceForProductInput!
    $where: EdshopifyCreatePriceForProductWhereInput!
  ) {
    edshopifyCreateSubscriptionPriceForProduct(data: $data, where: $where) {
      id
      productSubscriptionPlans {
        planName
        planShortDescription
        price
        currency
        frequency
      }
    }
  }
`;

export const UPDATE_PRODUCT_SUBSCRIPTION_PLAN = gql`
  mutation EdshopifyUpdateSubscriptionPriceForProduct(
    $data: EdshopifyCreateSubscriptionPriceForProductInput!
    $where: EdshopifyCreatePriceForProductWhereInput!
  ) {
    edshopifyUpdateSubscriptionPriceForProduct(data: $data, where: $where) {
      id
      planName
      planShortDescription
      price
      currency
      frequency
    }
  }
`;

export const UPDATE_PRODUCT_ONE_TIME_PLAN = gql`
  mutation EdshopifyUpdateOneTimePriceForProduct(
    $data: EdshopifyCreateOneTimePriceForProductInput!
    $where: EdshopifyCreatePriceForProductWhereInput!
  ) {
    edshopifyUpdateOneTimePriceForProduct(data: $data, where: $where) {
      id
      planName
      planShortDescription
      planLongDescription
      price
      currency
    }
  }
`;

export const CREATE_PRODUCT_ONE_TIME_PLAN = gql`
  mutation EdshopifyCreateOneTimePriceForProduct(
    $data: EdshopifyCreateOneTimePriceForProductInput!
    $where: EdshopifyCreatePriceForProductWhereInput!
  ) {
    edshopifyCreateOneTimePriceForProduct(data: $data, where: $where) {
      id
      productOneTimePlans {
        planName
        planShortDescription
        planLongDescription
        price
        currency
      }
    }
  }
`;

export const CREATE_AI_CONTENT = gql`
  mutation EdshopifyCreateAIProducts($where: EdshopifyWhereInput!, $data: EdshopifycreateAIProductsInput!) {
    edshopifyCreateAIProducts(where: $where, data: $data)
  }
`;

export const UPDATE_PUBLISHER = gql`
    mutation UpdatePublisher($data: PublisherUpdateInput!, $where: PublisherWhereUniqueInput!) {
        updatePublisher(where: $where, data: $data) {
            id
            publisherName
            owner {
                id
                email
            }
            additionalAdmins {
                ${userFields}
            }
            staff {
                ${userFields}
            }
            catalogs(orderBy: {
              createdAt: desc
            }) {
              id
              index
              catalogName
              heading
              subHeading
              catalogAdmins {
                ${userFields}
              }
              catalogStatus
              description
            }
            logoPath
            videoPath
            about
            otherInfo
            instagram
            facebook
            linkedin
            x
            seoTitle
            seoDescription
        }
    }
`;

export const UPDATE_MANY_DYNOES = gql`
  mutation UpdateManyDynoes(
    $where: DynoWhereInput
    $data: DynoUpdateManyMutationInput!
    $publisherId: String!
  ) {
    updateManyPublisherDynoes(
      where: $where
      data: $data
      publisherId: $publisherId
    ) {
      count
    }
  }
`;
export const CREATE_INSTRUCTOR = gql`
  mutation EdshopifyCreateInstructor($data: InstructorCreateInput!, $where: EdshopifyCreateSConnectedAccountWhereInput!) {
    edshopifyCreateInstructor(data: $data, where: $where) {
      id
      InstructorName
      InstructorBio
      InstructorPic
    }
  }
`;
export const UPDATE_INSTRUCTOR = gql`
  mutation UpdateInstructor($where: InstructorWhereUniqueInput!, $data: InstructorUpdateInput!) {
    updateInstructor(where: $where, data: $data) {
      id
      InstructorName
      InstructorBio
      InstructorPic
    }
  }
`;

export const CREATE_PRODUCT_CONTENT = gql`
  mutation CreateProductContent($where: ProductWhereUniqueInput!, $data: ProductUpdateInput!) {
    updateProduct(where: $where, data: $data) {
      id
      productName
      productContent {
        id
        dynoList(orderBy: {
          createdAt: desc
        }, take: 1) {
          id
          listIndex
          listName
          listTitle
          dynosUnderList {
            id
            index
            dyno {
              ${myDynosFields}
            }
          }
        }
      }
      catalog {
        id
        catalogName
      }
    }
  }
`;

export const UPDATE_DYNO_LIST = gql`
  mutation UpdateDynoList(
    $where: DynoListWhereUniqueInput!
    $data: DynoListUpdateInput!
  ) {
    updateDynoList(where: $where, data: $data) {
      id
      listName
      listTitle
      dynosUnderList {
        id
        isLocked
        index
      }
    }
  }
`;

export const DELETE_DYNO_LIST = gql`
  mutation DeleteDynoList($where: DynoListWhereUniqueInput!) {
    deleteDynoList(where: $where) {
      id
    }
  }
`;

export const UPDATE_DYNO = gql`
  mutation UpdateDyno($where: DynoWhereUniqueInput!, $data: DynoUpdateInput!) {
    updateDyno(where: $where, data: $data) {
      ${myDynosFields}
    }
  }
`;

export const DELETE_DYNO_FROM_LIST = gql`
  mutation DeleteDynoFromList (
    $data: DeleteDynoFromlistDataInput!
    $where: DeleteDynoFromlistWhereInput!
  ) {
    deleteDynoFromList(
      data: $data
      where: $where
    ) {
      listId
      dyno {
        ${myDynosFields}
      }
    }
  }
`;

export const LOCKUNLOCKALLDYNOS = gql`
  mutation LockUnlockAllDynoInProduct(
    $where: LockUnlockAllDynoInProductInput!
  ) {
    lockUnlockAllDynoInProduct(where: $where) {
      productContent {
        id
        dynoList(orderBy: { listIndex: asc }) {
          id
          dynosUnderList(orderBy: { index: asc }) {
            id
            index
            isLocked
          }
        }
      }
    }
  }
`;

export const ADD_DYNOS_TO_LIST = gql`
  mutation AddDynosToList($data:  AddDynosToListDataInput!, $where: AddDynosToListWhereInput!) {
    addDynosToList(data: $data, where: $where) {
      id
      dynosUnderList {
        id
        index
        dyno {
          ${myDynosFields}
        }
      }
    }
  }
`;

export const COPY_DYNO = gql`
  mutation CopyDyno($where: CopyDynoWhereUniqueInput!) {
    copyDyno(where: $where) {
      ${myDynosFields}
    }
  }
`;

export const MERGE_AND_CREATE_DYNO = gql`
  mutation MergeAndCreateDyno($data: MergeAndCreateDynoInput!) {
    mergeAndCreateDyno(data: $data) {
      id
      dynoTitle
    }
  }
`;

export const SPLIT_DYNO = gql`
  mutation SplitMultiQuesDynosToSingleQuesDyno($where: DynoWhereUniqueInput!, $data: SplitMultiQuesDynosToSingleQuesDynoCreateInput!) {
    splitMultiQuesDynosToSingleQuesDyno(where: $where, data: $data) {
      id
    }
  }
`;

export const UPDATE_PRODUCT_WITH_SPLIT_DYNO = gql`
  mutation UpdateProduct(
    $where: ProductWhereUniqueInput!
    $data: ProductUpdateInput!
  ) {
    updateProduct(where: $where, data: $data) {
      id
      productContent {
        id
        dynoList(orderBy: {listIndex: asc}) {
          id
          listIndex
          listName
          listTitle
          dynosUnderList(orderBy: {index: asc}) {
            id
            index
            dyno {
              ${myDynosFields}
            }
            isLocked
          }
        }
      }
    }
  }
`;

export const CREATE_AI_CHAPTERS = gql`
  mutation EdshopifyCreateAIChapters($where: EdshopifyWhereInput!, $data: EdshopifycreateAIChaptersInput!) {
    edshopifyCreateAIChapters(where: $where, data: $data)
  }
`;

export const DELETE_DYNO = gql`
  mutation EdshopifyDeleteDyno($where: EdshopifyDeleteDynoWhereInput!) {
    edshopifyDeleteDyno(where: $where) {
      id
    }
  }
`;

export const SHARE_DYNO_TO_LIST = gql`
  mutation ShareDynoToList (
    $data: shareDynoToListDataInput!
    $where: shareDynoToListWhereInput!
  ) {
    shareDynoToList(
      data: $data
      where: $where
    ) {
      listId
      dyno {
        ${myDynosFields}
      }
    }
  }
`;

export const CREATE_DYNO = gql`
  mutation CreateDyno($data: DynoCreateInput!) {
    createDyno(data: $data) {
      id
    }
  }
`;

export const DELETE_RESOURCE = gql`
  mutation EdshopifyDeleteResource($where: EdshopifyGenerateSasTokenWhereInput!) {
    edshopifyDeleteResource(where: $where)
  }
`;

export const DELETE_VIMEO_VIDEO = gql`
  mutation EdshopifyDeleteVimeoVideo($where: EdshopifyDeleteVimeoVideoWhereInput!) {
    edshopifyDeleteVimeoVideo(where: $where) {
      success
      message
    }
  }
`;

export const CREATE_READING_COMPREHENSION_DYNO = gql`
  mutation EdshopifyCreateReadingComprehensionDynoWithAI(
    $data: EdshopifyCreateReadingComprehensionDynoWithAIInput!
    $where: EdshopifyCreateReadingComprehensionDynoWithAIWhereInput!
  ) {
    edshopifyCreateReadingComprehensionDynoWithAI(data: $data, where: $where) {
      id
    }
  }
`;

export const CREATE_MATHS_CHART_DYNO = gql`
  mutation EdshopifyCreateMathsChartDynoWithAI(
    $data: EdshopifyCreateMathsChartDynoWithAIInput!
    $where: EdshopifyCreateMathsChartDynoWithAIWhereInput!
  ) {
    edshopifyCreateMathsChartDynoWithAI(data: $data, where: $where) {
      id
    }
  }
`;

export const CREATE_QUESTION_SETS_DYNO = gql`
  mutation EdshopifyCreateQuestionSetsDynoWithAI(
    $data: EdshopifyCreateQuestionSetsDynoWithAIInput!
    $where: EdshopifyCreateQuestionSetsDynoWithAIWhereInput!
  ) {
    edshopifyCreateQuestionSetsDynoWithAI(data: $data, where: $where) {
      id
    }
  }
`;

export const CREATE_GENERIC_DYNO = gql`
  mutation EdshopifyCreateGenericDynoWithAI(
    $data: EdshopifyCreateGenericDynoWithAIInput!
    $where: EdshopifyCreateGenericDynoWithAIWhereInput!
  ) {
    edshopifyCreateGenericDynoWithAI(data: $data, where: $where) {
      id
    }
  }
`;

export const CREATE_CONNECTED_ACCOUNT = gql`
  mutation EdshopifyCreateSConnectedAccount(
    $where: EdshopifyCreateSConnectedAccountWhereInput!
    $data: EdshopifyCreateSConnectedAccountInput!
  ) {
    edshopifyCreateSConnectedAccount(where: $where, data: $data) {
      id
    }
  }
`;

export const CREATE_CONNECTED_ACCOUNT_LINK = gql`
  mutation EdshopifyCreateSConnectedAccountLink(
    $where: EdshopifyCreateSConnectedAccountWhereInput!
    $data: EdshopifyCreateSConnectedAccountLinkInput!
  ) {
    edshopifyCreateSConnectedAccountLink(where: $where, data: $data) {
      url
    }
  }
`;

export const CREATE_CONNECTED_ACCOUNT_SESSION = gql`
  mutation EdshopifyCreateSConnectedAccountSession(
    $where: EdshopifyCreateSConnectedAccountWhereInput!
    $data: EdshopifyCreateSConnectedAccountSessionInput!
  ) {
    edshopifyCreateSConnectedAccountSession(where: $where, data: $data) {
      token
      expires_at
    }
  }
`;

export const CREATE_STRIPE_COUPON = gql`
  mutation EdshopifyCreateCoupon(
    $where: EdshopifyCreateSConnectedAccountWhereInput!
    $data: EdshopifyCreateCouponInput!
  ) {
    edshopifyCreateCoupon(where: $where, data: $data) {
      isSuccess
      isDuplicate
      couponCode
      couponExpiryDate
      isActive
      maxRedemption
      percentageOff
      pricingPlanType
      appliesToProduct {
        id
        productName
      }
      otherInfo
    }
  }
`;

export const UPDATE_STRIPE_COUPON = gql`
  mutation EdshopifyUpdateStripeCoupon(
    $where: EdshopifyUpdateStripeCouponWhereInput!
    $data: EdshopifyUpdateStripeCouponInput!
  ) {
    edshopifyUpdateStripeCoupon(where: $where, data: $data) {
      id
      isActive
    }
  }
`;

export const DELETE_STRIPE_COUPON = gql`
  mutation EdshopifyDeleteStripeCoupon(
    $where: EdshopifyDeleteStripeCouponWhereInput!
  ) {
    edshopifyDeleteStripeCoupon(where: $where) {
      id
    }
  }
`;

export const CREATE_PDF_DYNO = gql`
  mutation EdshopifyCreatePdfDyno(
    $where: EdshopifyCreatePdfDynoWhereInput!
    $data: createPdfDynoInput!
  ) {
    edshopifyCreatePdfDyno(where: $where, data: $data) {
      id
      otherInfo
    }
  }
`;

export const CREATE_VIDEO_DYNO = gql`
  mutation EdshopifyCreateVideoDyno(
    $where: EdshopifyCreateVideoDynoWhereInput!
    $data: EdshopifyCreateVideoDynoInput!
  ) {
    edshopifyCreateVideoDyno(where: $where, data: $data) {
      id
      otherInfo
    }
  }
`;

export const CREATE_READING_DYNO_WITH_AI_CONTEXT = gql`
  mutation EdshopifyCreateReadingDynoWithAIContext(
    $where: EdshopifyCreateReadingDynoWithAIContextWhereInput!
    $data: EdshopifyCreateReadingDynoWithAIContextInput!
  ) {
    edshopifyCreateReadingDynoWithAIContext(where: $where, data: $data) {
      id
    }
  }
`;
export const CREATE_QUESTION_SET_DYNO_WITH_AI_CONTEXT = gql`
  mutation EdshopifyCreateQuestionSetsDynoWithAIContext(
    $where: EdshopifyCreateQuestionSetsDynoWithAIContextWhereInput!
    $data: EdshopifyCreateQuestionSetsDynoWithAIContextInput!
  ) {
    edshopifyCreateQuestionSetsDynoWithAIContext(where: $where, data: $data) {
      id
    }
  }
`;
export const BUILD_EDSHOP = gql`
  mutation EdshopifyBuildStore(
    $where: EdshopifyBuildStoreWhereInput!
  ) {
    edshopifyBuildStore(where: $where) {
      id
    }
  }
`;
export const CREATE_EMBED_IMAGE_EDDOC = gql`
  mutation EdshopifyCreateEmbedImageDyno(
    $where: EdshopifyWhereInput!
    $data: EdshopifyCreateEmbedDynoInput!
  ) {
    edshopifyCreateEmbedImageDyno(where: $where, data: $data) {
      id
    }
  }
`;
export const CREATE_EMBED_VIDEO_EDDOC = gql`
  mutation EdshopifyCreateEmbedVideoDyno(
    $where: EdshopifyWhereInput!
    $data: EdshopifyCreateEmbedDynoInput!
  ) {
    edshopifyCreateEmbedVideoDyno(where: $where, data: $data) {
      id
    }
  }
`;
export const CREATE_EMBED_PDF_EDDOC = gql`
  mutation EdshopifyCreateEmbedPDFDyno(
    $where: EdshopifyWhereInput!
    $data: EdshopifyCreateEmbedDynoInput!
  ) {
    edshopifyCreateEmbedPDFDyno(where: $where, data: $data) {
      id
    }
  }
`;
export const CREATE_EMBED_AUDIO_EDDOC = gql`
  mutation EdshopifyCreateEmbedAudioDyno(
    $where: EdshopifyWhereInput!
    $data: EdshopifyCreateEmbedDynoInput!
  ) {
    edshopifyCreateEmbedAudioDyno(where: $where, data: $data) {
      id
    }
  }
`;
export const CREATE_ABOUT_SEO_WITH_AI = gql`
  mutation EdshopifyCreateStoreAboutAndSEOWithAI(
    $where: EdshopifyWhereInput!
    $data: EdshopifyCreateStoreAboutAndSEOWithAIInput!
  ) {
    edshopifyCreateStoreAboutAndSEOWithAI(where: $where, data: $data) {
      about
      seoTitle
      seoDescription
      logoImage
    }
  }
`;
export const CREATE_EMBED_PPT_EDDOC = gql`
  mutation EdshopifyCreateEmbedPptDyno(
    $where: EdshopifyWhereInput!
    $data: EdshopifyCreateEmbedPptDynoInput!
  ) {
    edshopifyCreateEmbedPptDyno(where: $where, data: $data) {
      id
    }
  }
`;
export const UPGRADE_TO_PRO = gql`
  mutation EdshopifyCheckoutForProAccount(
    $data: EdshopifyCheckoutProductInput!
  ) {
    edshopifyCheckoutForProAccount(data: $data) {
      url
    }
  }
`;
export const CANCEL_SUBSCRIPTION_PLAN = gql`
  mutation EdshopifyCancelStripeSubForProAccount(
    $where: EdshopifyWhereInput!
  ) {
    edshopifyCancelStripeSubForProAccount(where: $where) {
      id
    }
  }
`;
export const CUSTOMER_PORTAL = gql`
  mutation EdshopifyCustomerPortalForPublisher(
    $where: EdshopifyWhereInput!
  ) {
    edshopifyCustomerPortalForPublisher(where: $where)
  }
`;
export const GET_ADDITIONAL_CREDITS = gql`
  mutation EdshopifyCheckoutAdditionalCredits(
    $data: EdshopifyCheckoutProductInput!,
    $where: EdshopifyWhereInput!
  ) {
    edshopifyCheckoutAdditionalCredits(data: $data, where: $where) {
      url
    }
  }
`;

export const CREATE_READING_DYNO_WITH_AI_CONTEXT_TEMPLATE = gql`
  mutation EdshopifyCreateReadingDynoWithAIContextTemplate(
    $where: EdshopifyCreateReadingDynoWithAIContextTemplateWhereInput!
    $data: EdshopifyCreateReadingDynoWithAIContextTemplateInput!
  ) {
    edshopifyCreateReadingDynoWithAIContextTemplate(where: $where, data: $data) {
      id
    }
  }
`;

export const CREATE_READING_COMPREHENSION_DYNO_TEMPLATE = gql`
  mutation EdshopifyCreateReadingComprehensionDynoWithAITemplate(
    $where: EdshopifyCreateReadingComprehensionDynoWithAITemplateWhereInput!
    $data: EdshopifyCreateReadingComprehensionDynoWithAITemplateInput!
  ) {
    edshopifyCreateReadingComprehensionDynoWithAITemplate(data: $data, where: $where) {
      id
    }
  }
`;